<template>
  <vueper-slides
    class="no-shadow"
    :visible-slides="5"
    slide-multiple
    :gap="0"
    :slide-ratio="1 / 4"
    :bullets="false"
    arrows-outside
    :dragging-distance="200"
    fixed-height="250px"
    :breakpoints="{ 670: { visibleSlides: 1, slideMultiple: 1 }, 800: { visibleSlides: 3, slideMultiple: 1 }, 990: { visibleSlides: 3, slideMultiple: 1 }, 1025: { visibleSlides: 4, slideMultiple: 1 } }"
  >
    <vueper-slide v-if="loading">
      <template v-slot:content>
        <b-spinner label="Spinning" style="margin-top:50px;"></b-spinner>
      </template>
    </vueper-slide>
    <vueper-slide v-else v-for="item in junta" :key="item.id">
      <template v-slot:content>
       <b-img :src="imgSrc(item.foto.guid)" class="junta-pic" />
        <p class="person-name">{{item.nombre}}</p>
        <p class="person-position">{{item.asociaon}}</p>
        <p class="person-position">{{item.cargo}}</p>
      </template>
    </vueper-slide>
  </vueper-slides>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import axios from "axios";
import config from "../../public/data/config.json"
export default {
  async mounted() {
    this.loading = true;
    try {
      const results = await axios.get(
        config.URL+"/junta_directiva/?per_page=100"
      );

      this.junta = results.data.reverse();
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  data() {
    return {
      loading: false,
      junta: []
    };
  },
  methods: {
    imgSrc(img) {
      return img || 'https://via.placeholder.com/150'
    }
  },
  components: {
    VueperSlides,
    VueperSlide
  }
};
</script>
<style scoped>
.junta-pic {
  border-radius: 25px;
  max-width: 150px;
  height: auto;
}
.person-name {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 5px;
}
.person-position {
  font-size: 12px;
  font-weight: 400;
  color: gray;
  margin-top: 0px;
  text-align: center;
  margin-bottom: 1px;
}
</style>
